import { appBreakpoints } from "@/utils/theme";
import { useBreakpoints } from "@vueuse/core";
import {
  inject,
  provide,
  ref,
  watchEffect,
  type InjectionKey,
  type Ref,
} from "vue";

const responsiveHelpersInjectionKey = Symbol(
  "responsiveHelpers",
) as InjectionKey<ReturnType<typeof useProvideResponsiveHelpers>>;

export function useProvideResponsiveHelpers() {
  const { desktop, largeDesktop } = useBreakpoints({
    desktop: appBreakpoints.desktop,
    largeDesktop: appBreakpoints["large-desktop"],
  });
  const canHover = ref(true);

  watchEffect((onCleanup) => {
    const query = window.matchMedia("(hover: hover)");
    const listener = () => {
      canHover.value = query.matches;
    };

    query.addEventListener("change", listener);
    onCleanup(() => query.removeEventListener("change", listener));
  });

  const definition = {
    desktop: desktop as Ref<boolean>,
    largeDesktop: largeDesktop as Ref<boolean>,
    canHover,
  };

  provide(responsiveHelpersInjectionKey, definition);
  return definition;
}

export function useResponsiveHelpers() {
  const value = inject(responsiveHelpersInjectionKey);

  if (!value) {
    throw new Error(
      "useResponsiveHelpers() is called without providing the context",
    );
  }

  return value;
}
